import { useContext } from "react";
import { QuestionnaireForm } from "./context";

export const useQuestionnaireFormContext = () => {
    const context = useContext(QuestionnaireForm);

    if (context) {
        return context;
    }

    throw new Error(`useQuestionnaireFormContext must be used within a QuestionnaireFormProvider`);
};
